import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerFamily } from './families.types';

const useDeleteConsumerFamily = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const deleteConsumerFamily = async ({ familyId }: { familyId: string }) => {
    const { data } = await BackerApi.delete<ConsumerFamily>(`/consumer/families/${familyId}`);
    return data;
  };
  return useMutation({
    mutationFn: deleteConsumerFamily,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.families.all });
    },
  });
};

const useDeleteConsumerFamilyBacker = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const deleteConsumerFamilyBacker = async ({
    familyId,
    backerId,
  }: {
    familyId: string;
    backerId: string;
  }) => {
    const { data } = await BackerApi.delete<ConsumerFamily>(
      `/consumer/families/${familyId}/backers/${backerId}`
    );
    return data;
  };
  return useMutation({
    mutationFn: deleteConsumerFamilyBacker,
    onSuccess: (_, variables) => {
      const { familyId } = variables;
      void queryClient.invalidateQueries({
        queryKey: backerKeys.consumer.families.id(familyId).all,
      });
    },
  });
};

const useDeleteConsumerFamilyChild = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const deleteConsumerFamilyChild = async ({
    familyId,
    childId,
  }: {
    familyId: string;
    childId: string;
  }) => {
    const { data } = await BackerApi.delete<ConsumerFamily>(
      `/consumer/families/${familyId}/children/${childId}`
    );
    return data;
  };
  return useMutation({
    mutationFn: deleteConsumerFamilyChild,
    onSuccess: (_, variables) => {
      const { familyId } = variables;
      void queryClient.invalidateQueries({
        queryKey: backerKeys.consumer.families.id(familyId).all,
      });
    },
  });
};

export { useDeleteConsumerFamily, useDeleteConsumerFamilyBacker, useDeleteConsumerFamilyChild };
